import React from "react";
import { useTableData } from "../../hooks/table";
import { useGetReportFile } from "../../hooks/api";
import { ExcelButton } from "../../../../../modules/Dashboard/components/Filters/ExcelButton";
import { ReportTableWrapper } from "../ReportTableWrapper";
import { createColumnOptions } from "../../utils";
import { adminColumns, createColumns } from "../../utils";
import { getItem } from "../../../../../system/helpers/localstorageHelper";
import { permissions } from "../../../../../system/constants/roles";

const ReportPage = ({ config, ReportFilters }) => {
  const {
    columns: allColumns,
    hiddenColumns,
    columnsKey,
    stateSelector,
    api,
    fileName,
    apiKey,
    dispatchCallback,
    filteredColumns,
    subtotals,
    additionalFilterOptions,
  } = config;
  const limitedColumns = allColumns.filter(
    (column) => !adminColumns.includes(column)
  );
  const columns = permissions.user_permission.admin.includes(getItem("role"))
    ? allColumns
    : limitedColumns;

  const { setFilters, filters, data, isLoading, reqFilters } = useTableData(
    stateSelector,
    dispatchCallback,
    api,
    apiKey
  );
  const [getFile, { isLoading: isFileLoading }] = useGetReportFile(
    api,
    fileName,
    reqFilters
  );

  const clickHandler = () => {
    getFile();
  };

  return (
    <div>
      <ReportFilters
        setFilters={setFilters}
        initialValues={filters}
        excelButton={
          <ExcelButton clickHandler={clickHandler} isLoading={isFileLoading} />
        }
      />
      <ReportTableWrapper
        data={data}
        isLoading={isLoading}
        allColumns={createColumns(columns)}
        hiddenColumns={hiddenColumns}
        visibleColumnsKey={columnsKey}
        columnsOptions={createColumnOptions(columns, hiddenColumns)}
        setFilters={setFilters}
        stateSelector={stateSelector}
        dispatchCallback={dispatchCallback}
        filteredColumns={filteredColumns}
        additionalFilterOptions={additionalFilterOptions}
        subtotalsColumns={subtotals}
      />
    </div>
  );
};

export default ReportPage;
